import { render, staticRenderFns } from "./CodePreview.vue?vue&type=template&id=2a419dea"
import script from "./CodePreview.vue?vue&type=script&lang=js"
export * from "./CodePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports